// Helper function to parse array values from query params
export const parseArrayParam = (param) => {
  if (!param) return []
  if (Array.isArray(param)) return param
  if (typeof param === 'string') {
    // Support comma-separated values
    return param
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean)
  }
  return []
}

// Helper function to parse boolean values from query params
export const parseBooleanParam = (param, defaultValue = false) => {
  if (param === undefined) return defaultValue
  if (typeof param === 'string') {
    return param.toLowerCase() === 'true' || param === '1'
  }
  return defaultValue
}

// Helper function to parse selection states from query params
export const parseSelectionParam = (param) => {
  if (!param) return {}
  if (typeof param === 'string') {
    const result = {}
    // Parse format like "value1:true,value2:false"
    param.split(',').forEach((pair) => {
      const [value, selected] = pair.split(':')
      if (value && selected !== undefined) {
        result[value.trim()] = selected.trim() === 'true'
      }
    })
    return result
  }
  return {}
}

// Parse query parameters into form default values
export const parseQueryParams = (query) => {
  return {
    forceCountry: (typeof query.forceCountry === 'string' ? query.forceCountry : 'US') || 'US',
    forcePreferences: parseArrayParam(query.forcePreferences),
    forcePreferencesSelected: parseSelectionParam(query.forcePreferencesSelected),
    forcePermissions: parseArrayParam(query.forcePermissions),
    forcePermissionsSelected: parseSelectionParam(query.forcePermissionsSelected),
    forceRussianAccess: parseBooleanParam(query.forceRussianAccess, false),
    forceTempleViewable: parseBooleanParam(query.forceTempleViewable, true),
    forceChurchMembership: parseBooleanParam(query.forceChurchMembership, true),
    forceSignedOut: parseBooleanParam(query.forceSignedOut, false),
  }
}
